const PrimaryButton = (props) => {
    const { label, ...buttonProps } = props
    return (
        <button {...buttonProps} className=' bg-primary text-white px-8 py-3 rounded-lg font-semibold'>{label}</button>
    )
}

export default PrimaryButton
